import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/axios';
import { toast } from 'sonner';

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Use ref to prevent duplicate processing
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        console.log('Processing Google OAuth callback, sessionId:', sessionId ? 'present' : 'missing');

        if (!sessionId) {
          toast.error('Respuesta de autenticación inválida');
          navigate('/login');
          return;
        }

        // Exchange session_id for user data
        const response = await api.post(
          '/auth/google-session',
          { session_id: sessionId }
        );

        console.log('Google session response:', response.data);

        // Check if pending approval
        if (response.data.pending_approval) {
          toast.success('¡Solicitud enviada! Tu cuenta está pendiente de aprobación. Te notificaremos por email cuando sea aprobada.', {
            duration: 8000
          });
          navigate('/login', { replace: true });
          return;
        }

        // Store JWT token
        if (response.data.token) {
          localStorage.setItem('jwt_token', response.data.token);
          console.log('JWT token stored successfully');
        }

        setUser(response.data.user);
        
        // Navigate to dashboard
        toast.success(`¡Bienvenido, ${response.data.user?.name || 'Usuario'}!`);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Google Auth error:', error.response?.data || error.message);
        
        // More specific error messages
        const errorMessage = error.response?.data?.detail || 'Error de autenticación. Intenta de nuevo.';
        toast.error(errorMessage);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37] mx-auto mb-4"></div>
        <p className="text-[#808080]">Autenticando...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
